import { useMemo } from "react";
import { withNamespaces } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Button, Card, CardBody, CardTitle } from "reactstrap";
import workflowIcon from "src/modules/data-protection/assets/images/workflow.svg";
import { buildOptionLabelMap } from "src/modules/data-protection/pages/admin/software/details/tabs-content/info-cards/data-flow-v2/helpers/flowCards";
import useDataFlowOptions from "src/modules/data-protection/pages/admin/software/details/tabs-content/info-cards/data-flow-v2/hooks/useDataFlowOptions";
import {
    INFORMATION_ACCORDIONS,
    buildInformationTabPath,
} from "src/modules/data-protection/pages/admin/software/details/tabs-content/information/helpers/accordionDeepLink";
import DataFlowGraph from "./components/DataFlowGraph";
import buildDataFlowGraph from "./utils/buildDataFlowGraph";

const DataFlowCard = ({
    t,
    softwareData,
    dataFlow = {},
    degraded = false
}) => {
    const history = useHistory();
    const { data: options = {} } = useDataFlowOptions({ t });
    const methodLabels = useMemo(
        () => buildOptionLabelMap(options.transfer_methods),
        [options.transfer_methods]
    );
    const typeLabels = useMemo(
        () => buildOptionLabelMap(options.data_types),
        [options.data_types]
    );
    const relationLabels = useMemo(
        () => buildOptionLabelMap(options.relations),
        [options.relations]
    );
    const graph = useMemo(
        () =>
            buildDataFlowGraph({
                softwareName: softwareData?.service,
                v2: dataFlow.v2,
                methodLabels,
                typeLabels,
                relationLabels,
                t
            }),
        [
            dataFlow.v2,
            methodLabels,
            relationLabels,
            softwareData?.service,
            t,
            typeLabels
        ]
    );

    const goToBasicInformation = () => {
        history.push(
            buildInformationTabPath(
                softwareData?.id,
                INFORMATION_ACCORDIONS.DATA_FLOW
            )
        );
    };

    return (
        <Card className="overview-sustainability-card h-100 mb-0">
            <CardBody>
                <CardTitle className="overview-section-title mb-1">
                    {t("Data flow")}
                </CardTitle>
                <p className="text-muted mb-4">
                    {t(
                        "See how data enters, moves through, and leaves this software"
                    )}
                </p>
                {!graph || degraded ? (
                    <div className="overview-data-flow__empty">
                        <img
                            src={workflowIcon}
                            alt=""
                            className="overview-data-flow__empty-icon"
                        />
                        <h6 className="mb-2">
                            {t("No software data flows recorded.")}
                        </h6>
                        <Button
                            color="primary"
                            type="button"
                            onClick={goToBasicInformation}
                        >
                            + {t("Add data flow")}
                        </Button>
                        <button
                            type="button"
                            className="overview-data-flow__link"
                            onClick={goToBasicInformation}
                        >
                            {t("Configure in Basic Info")}
                            {" → "}
                            {t("Data Flow")}
                        </button>
                    </div>
                ) : (
                    <DataFlowGraph graph={graph} />
                )}
            </CardBody>
        </Card>
    );
};

export default withNamespaces()(DataFlowCard);
